<script context="module">
</script>

<script>
  import { createEventDispatcher, onMount } from "svelte";
  // import { encodingToHex, hexToEncoding } from "bitframes";
  // import { loadHighlight, userState } from "../util/highlight-loader.js";
  // import { shortAddress } from "../util/shortAddress.js";
  // import SignInButton from "./SignInButton.svelte";
  import {
    createEtherscanLink,
    ETH_PRICE,
    LINK_ABOUT,
    LINK_GALLERY,
  } from "../util/constants.js";
  import ExternalLink from "./ExternalLink.svelte";
  import Button from "./Button.svelte";

  export let tokenId;
  export let txHash;
  const dispatch = createEventDispatcher();
  onMount(() => {});

  function closeModal() {
    dispatch("close");
  }
</script>

<div class="container">
  <div class="info">
    Update submitted! The new encoding and design for <strong
      >32 Bit Edition #{tokenId}</strong
    > should be updated on the public gallery within the next several minutes.
  </div>
  <!-- to={`/${LINK_GALLERY}/token/${tokenId}?reveal=${txHash}` -->
  <div class="token">
    <Button on:click={closeModal} text="View Token"></Button>
  </div>
  <div class="tx">
    <ExternalLink href={createEtherscanLink({ type: "tx", fragment: txHash })}
      >View Transaction in Block Explorer
    </ExternalLink>
  </div>
</div>

<style>
  .info strong {
    display: inline-flex;
  }
  .token {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .container {
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    box-sizing: border-box;
    /* max-width: 500px; */
  }
</style>
